/* MATOSHI cart API — one interface, two adapters.
   Preview uses localStorage; on Shopify the same calls hit /cart/*.js.
   UI code must only ever talk to window.MatoshiCart. */
(function () {
  'use strict';
  // Bildquelle aus der Datenisel: vollständige URLs (Shopify-CDN) und absolute
  // Pfade unverändert lassen, reine Dateinamen auf den Asset-Ordner beziehen.
  window.MatoshiImg = function (x) {
    x = x || '';
    return /^(https?:)?\/\//.test(x) || x.charAt(0) === '/' ? x : '/assets/' + x;
  };
  var KEY = 'matoshi.cart.v1';
  var listeners = [];
  window.MatoshiEscape = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function products() { return window.__MATOSHI_PRODUCTS__ || []; }
  function findVariant(id) {
    id = String(id);
    for (var i = 0; i < products().length; i++) {
      var p = products()[i];
      for (var j = 0; j < p.variants.length; j++) {
        if (String(p.variants[j].id) === id) return { product: p, variant: p.variants[j] };
      }
    }
    return null;
  }

  /* ---------- Local adapter (preview) ---------- */
  function LocalAdapter() {}
  LocalAdapter.prototype.read = function () {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  };
  LocalAdapter.prototype.write = function (items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* private mode */ }
  };
  LocalAdapter.prototype.build = function () {
    var raw = this.read(), items = [], total = 0;
    for (var i = 0; i < raw.length; i++) {
      var hit = findVariant(raw[i].id);
      if (!hit) continue;
      var line = hit.variant.price * raw[i].qty;
      total += line;
      items.push({
        key: String(raw[i].id), id: hit.variant.id, quantity: raw[i].qty,
        title: hit.product.title, product_title: hit.product.title,
        variant_title: hit.variant.title === 'Default Title' ? null : hit.variant.title,
        url: hit.product.url, image: window.MatoshiImg(hit.product.image),
        price: hit.variant.price, final_price: hit.variant.price, line_price: line,
        handle: hit.product.handle, series: hit.product.series,
        product_type: hit.product.type, preorder: hit.product.preorder,
      });
    }
    return { item_count: items.reduce(function (s, i) { return s + i.quantity; }, 0), items: items, total_price: total, items_subtotal_price: total, currency: 'EUR' };
  };
  LocalAdapter.prototype.get = function () { return Promise.resolve(this.build()); };
  LocalAdapter.prototype.add = function (id, qty) {
    var raw = this.read(), found = false;
    for (var i = 0; i < raw.length; i++) if (String(raw[i].id) === String(id)) { raw[i].qty += qty; found = true; }
    if (!found) raw.push({ id: String(id), qty: qty });
    this.write(raw);
    return this.get();
  };
  LocalAdapter.prototype.change = function (key, qty) {
    var raw = this.read(), out = [];
    for (var i = 0; i < raw.length; i++) {
      if (String(raw[i].id) === String(key)) { if (qty > 0) { raw[i].qty = qty; out.push(raw[i]); } }
      else out.push(raw[i]);
    }
    this.write(out);
    return this.get();
  };
  LocalAdapter.prototype.clear = function () { this.write([]); return this.get(); };

  /* ---------- Shopify adapter (production) ---------- */
  function ShopifyAdapter() {}
  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) { return r.json().then(function (data) {
      if (!r.ok) throw new Error(data.description || data.message || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
      return data;
    }); });
  }
  function route(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path; }
  ShopifyAdapter.prototype.get = function () { return json(route('cart.js')); };
  ShopifyAdapter.prototype.add = function (id, qty, props) {
    return json(route('cart/add.js'), { items: [{ id: id, quantity: qty, properties: props || {} }] }).then(this.get);
  };
  ShopifyAdapter.prototype.change = function (key, qty) { return json(route('cart/change.js'), { id: key, quantity: qty }); };
  ShopifyAdapter.prototype.clear = function () { return json(route('cart/clear.js'), {}); };

  var adapter = (typeof window.Shopify !== 'undefined') ? new ShopifyAdapter() : new LocalAdapter();

  function emit(cart) {
    for (var i = 0; i < listeners.length; i++) { try { listeners[i](cart); } catch (e) { console.error(e); } }
    document.dispatchEvent(new CustomEvent('matoshi:cart', { detail: cart }));
  }
  var pending = Promise.resolve();
  function mutate(operation) {
    var result = pending.then(operation).then(function (cart) { emit(cart); return cart; });
    pending = result.catch(function () {});
    return result;
  }

  window.MatoshiCart = {
    mode: (adapter instanceof ShopifyAdapter) ? 'shopify' : 'local',
    format: euro,
    get: function () { return pending.then(function () { return adapter.get(); }).then(function (c) { emit(c); return c; }); },
    add: function (id, qty, props) { return mutate(function () { return adapter.add(id, qty || 1, props); }); },
    change: function (key, qty) {
      return mutate(function () { return adapter.change(key, qty); });
    },
    clear: function () { return mutate(function () { return adapter.clear(); }); },
    subscribe: function (fn) { listeners.push(fn); return function () { listeners = listeners.filter(function (f) { return f !== fn; }); }; },
    threshold: function () {
      var el = document.querySelector('[data-free-shipping-threshold]');
      return el ? parseInt(el.getAttribute('data-free-shipping-threshold'), 10) * 100 : 4900;
    },
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.MatoshiCart.get().catch(function (e) {
      // Ein fehlgeschlagener Erstabruf darf die Seite nicht mit einer
      // unbehandelten Ausnahme belasten; der Warenkorb bleibt dann leer.
      if (window.console) console.warn('Warenkorb konnte nicht geladen werden:', e && e.message);
    });
  });
})();
